import { Injectable } from '@angular/core';
import { FC_GabineteCoolerFan } from '../funcionesCompatibilidad/FC_GabineteCoolerFan';
import { Incompatibilities } from '../Incompatibilities';
import { CoolerFan } from '../model/CoolerFan';
import { DataArmado } from './DataArmado';
import { FuncionesArmadoBase } from './FuncionesArmadoBase';
import { IncompatibilitiesType } from '@core/enums/incompatibilities-types.enum';

@Injectable({
  providedIn: 'root',
})
export class FA_CoolerFan extends FuncionesArmadoBase<CoolerFan> {
  constructor(private fc_gabineteCoolerFan: FC_GabineteCoolerFan) {
    super();
  }
  funciones = {
    gabinete: (dataArmado: DataArmado, coolerfan: CoolerFan) => {
      let gabinete = dataArmado.gabinetes[0];
      if (!gabinete) return [];
      return this.fc_gabineteCoolerFan.ejecutar(gabinete, coolerfan);
    },
    cantidad: (dataArmado: DataArmado, coolerfan: CoolerFan): Incompatibilities[] => {
      let tipoCooler = coolerfan.$caracteristicas.dimensiones;
      let cantidadMaxima = { 120: 6, 140: 6, 80: 6, 200: 6 };
      let gabinete = dataArmado.gabinetes[0];
      if (gabinete) {
        cantidadMaxima[120] = gabinete.$caracteristicas.cf_120mm;
        cantidadMaxima[140] = gabinete.$caracteristicas.cf_140mm;
        cantidadMaxima[80] = gabinete.$caracteristicas.cf_80mm;
        cantidadMaxima[200] = gabinete.$caracteristicas.cf_200mm;
      }
      let cantidadCoolerFanSeleccionados = dataArmado.perifericos
        .filter((periferico) => periferico instanceof CoolerFan)
        .reduce(
          (result, coolerFanActual) => {
            let dimensionesCoolerFanActual = coolerFanActual.$caracteristicas.dimensiones;
            let cantidad: number = result[dimensionesCoolerFanActual] + 1 || 1;
            result[dimensionesCoolerFanActual] = cantidad;
            return result;
          },
          {} as { [x: string]: number },
        );

      const incompatibilidades: Array<Incompatibilities> = [];
      let saldo: number = Object.values(cantidadMaxima).reduce((prev, curr) => prev + curr);

      for (const dimension in cantidadCoolerFanSeleccionados) {
        if (
          cantidadMaxima[dimension] < cantidadCoolerFanSeleccionados[dimension] &&
          +dimension == tipoCooler
        ) {
          incompatibilidades.push({
            tipo: IncompatibilitiesType.ARMADO,
            incompatibility: `Excede la cantidad máxima de cooler fan de ${dimension}mm`,
          });
        }
        if (
          cantidadMaxima[dimension] == cantidadCoolerFanSeleccionados[dimension] &&
          +dimension == tipoCooler
        ) {
          incompatibilidades.push({
            tipo: IncompatibilitiesType.PARCIAL,
            incompatibility: `El gabinete no soporta otro cooler fan de ${dimension}mm`,
          });
        }
        saldo -= cantidadCoolerFanSeleccionados[dimension];
      }

      if (!saldo) {
        incompatibilidades.push({
          tipo: IncompatibilitiesType.CANTIDAD,
          incompatibility: `El gabinete no soporta más cooler Fan`,
        });
      }

      return incompatibilidades?.length ? incompatibilidades : null;
    },
  };
}
